"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TeamMessageInput = _interopRequireDefault(require("./TeamMessageInput/TeamMessageInput"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _TeamMessageInput.default;
exports.default = _default;